import React, { useState } from 'react'
import { Typography, Modal, Form, Button, Row, Col } from 'antd'
import { Formik, Field } from 'formik'

import NumberField from '../../../shared/NumberField'
import { setSpecialReleaseRetriever } from '../../../../schema/setSpecialReleaseRetriever'

const SetSpecialReleaseRetrieverModal = ({
  trigger,
  onSubmit,
  title,
  assignedSpecialReleaseRetrieverId = null,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleOpenModal = e => {
    e.preventDefault()
    setIsModalVisible(!isModalVisible)
  }

  return (
    <>
      {React.cloneElement(trigger, {
        onClick: handleOpenModal,
      })}
      <Modal
        visible={isModalVisible}
        footer={null}
        closable={false}
        destroyOnClose
        centered
        onCancel={() => setIsModalVisible(false)}
        maskStyle={{
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Typography.Title level={3}>{title}</Typography.Title>
        <Formik
          enableReinitialize
          initialValues={{ id: assignedSpecialReleaseRetrieverId }}
          onSubmit={async (...data) => {
            try {
              await onSubmit(...data)
              setIsModalVisible(false)
            } catch (err) {
              /* empty */
            }
          }}
          validationSchema={setSpecialReleaseRetriever}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <Form onFinish={handleSubmit} layout="vertical">
              <Field
                component={NumberField}
                placeholder="Type here or leave blank"
                name="id"
                label="Special Release Retriever CMS ID"
                validateOnChange
              />
              <Row justify="space-between" align="middle">
                <Col>
                  <Button onClick={handleOpenModal}>Close window</Button>
                </Col>
                <Col>
                  <Button type="primary" htmlType="submit" disabled={!isValid || !dirty}>
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  )
}

export default SetSpecialReleaseRetrieverModal
